import { createDriver, updateDriver } from 'api/drivers';
import { debouncePartner, debounceProject, debounceRegional } from 'utils/debounces';

import type { FormType } from '..';

export const driverForm: FormType = {
  createFn: createDriver,
  updateFn: updateDriver,
  cancelText: 'Cancelar',
  submitText: 'Salvar Condutor',
  disableText: 'Desativar Condutor',
  enableText: 'Reativar Condutor',
  successText: 'Condutor salvo com sucesso!',
  fields: [
    [{
      name: 'name',
      type: 'text',
      required: true,
      props: {
        placeholder: 'Nome do condutor',
        label: 'Nome',
      },
    }],
    [{
      name: 'email',
      type: 'text',
      required: true,
      props: {
        placeholder: 'exemplo@email.com',
        label: 'Email',
      },
    },
    {
      name: 'phone',
      type: 'text',
      required: true,
      mask: 'maskPhone',
      props: {
        placeholder: '(00) 9 9876-5432',
        label: 'Telefone',
      },
    }],
    [{
      name: 'project',
      type: 'select',
      required: false,
      props: {
        placeholder: 'Buscar',
        label: 'Projeto',
        loadOptions: debounceProject,
      },
    }],
    [{
      name: 'regional',
      type: 'select',
      required: false,
      props: {
        placeholder: 'Buscar',
        label: 'Regional',
        loadOptions: debounceRegional,
      },
    }],
    [{
      name: 'partner',
      type: 'select',
      required: false,
      props: {
        placeholder: 'Buscar',
        label: 'Parceiro',
        loadOptions: debouncePartner,
      },
    }],
    [],
    [
      {
        name: 'documentNumber',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Ex: 00000000000',
          label: 'CNH',
        },
      }, {
        name: 'documentNumberDueDate',
        type: 'date',
        required: true,
        props: {
          placeholder: 'Ex: 01/01/2000',
          label: 'Data de Validade',
        },
      },
    ],
    [
      {
        name: 'ear',
        type: 'text',
        required: false,
        props: {
          placeholder: 'Ex: 00000000000',
          label: 'EAR',
        },
      }, {
        name: 'earDueDate',
        type: 'date',
        required: false,
        props: {
          placeholder: 'Ex: 01/01/2000',
          label: 'Data de Validade',
        },
      },
    ],
    [
      {
        name: 'mopp',
        type: 'text',
        required: false,
        props: {
          placeholder: 'Ex: 00000000000',
          label: 'MOPP',
        },
      }, {
        name: 'moppDueDate',
        type: 'date',
        required: false,
        props: {
          placeholder: 'Ex: 01/01/2000',
          label: 'Data de Validade',
        },
      },
    ],
  ],
};
